import cx from "classnames";

import AssistantPanelAskButton from "components/AssistantPanel/AskButton";
import useIsAssistantPageMode from "components/AssistantPanel/hooks/useIsAssistantPageMode";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import { selectNavigationShowsExpandedContent } from "components/MainNavigation/selectors/navigationState";
import useMainNavigationFadeTransition from "components/MainNavigation/hooks/useFadeTransition";
import Tooltip from "ds/components/Tooltip";
import { TooltipReferenceProps } from "ds/components/Tooltip/types";

import styles from "./styles.module.css";

const MainNavigationAskButton = () => {
  const showsExpandedContent = useMainNavigationStore(selectNavigationShowsExpandedContent);
  const isAssistantPageMode = useIsAssistantPageMode();
  const { transitionClasses } = useMainNavigationFadeTransition(!!showsExpandedContent);

  return (
    <Tooltip
      active={isAssistantPageMode}
      on={(props: TooltipReferenceProps) => (
        <AssistantPanelAskButton
          {...props}
          entryPoint="main_nav_ask"
          className={cx(props.className, styles.ask, transitionClasses)}
          size="small"
          disabled={isAssistantPageMode}
        />
      )}
    >
      Not available on this page
    </Tooltip>
  );
};

export default MainNavigationAskButton;
